import { useMutation } from '@tanstack/react-query'

import { apiGetOrderAvailability, type GetOrderAvailabilityParams } from '@/apis/order/getOrderAvailability'
import type { OrderAvailability } from '@/types/order'

/**
 * 주문 가능여부 검증 mutation — "수거 신청하기" 클릭 시 명시적 트리거.
 *
 * useGetOrderAvailability(query)와 차이:
 *  - 1차 검증 = useGetOrderAvailability (주소 클릭 직후 자동 fetch, 캐시 활용)
 *  - 2차 검증 = 본 훅 (수거 신청 클릭 시 명시 호출)
 *  - 1차 OK 후 백엔드 상태 변동(미납 발생 등) 가능성 방어 + 사용자 의도 시점 재검증
 *
 * 사용자 액션 직후 호출이라 retry 무의미 → mutation 일회성 트리거가 의도에 정확히 맞음.
 * onSuccess/onError 콜백에서 bridge onApply / onError 분기 처리는 호출자(컴포넌트) 책임.
 */
export const useCheckOrderAvailability = () =>
  useMutation<OrderAvailability, unknown, GetOrderAvailabilityParams>({
    mutationFn: (params) => apiGetOrderAvailability(params),
  })
